import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	AccountTransaction,
	AccountTransactionRegistryFilters,
	createAccountTransactionRegistryQuery,
} from 'shared/api';
import {
	createDateFilterModel,
	createRegistryModel,
	DateFilterModel,
	getToday,
	RegistryCallbacks,
	RegistryModel,
	SORT_DIRECTIONS,
} from 'shared/lib';

export type AccountTransactionRegistryModel = {
	registryModel: RegistryModel<
		AccountTransaction,
		AccountTransactionRegistryFilters,
		JsonApiRequestError
	>;
	dateFilterModel: DateFilterModel;
};

type CreateAccountTransactionRegistryModelParams = {
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export const createAccountTransactionRegistryModel = ({
	$accountId,
	...params
}: CreateAccountTransactionRegistryModelParams): AccountTransactionRegistryModel => {
	const query = createAccountTransactionRegistryQuery($accountId);

	const [, currentTimeZone] = getToday();

	const registryModel = createRegistryModel<
		AccountTransaction,
		AccountTransactionRegistryFilters,
		JsonApiRequestError
	>({
		query,
		filters: {
			accountIds: [],
			currencies: [],
			types: [],
			dateFrom: '',
			dateTo: '',
			timeZone: currentTimeZone,
		},
		limit: 10,
		sortField: 'date',
		sortDirection: SORT_DIRECTIONS.DESC,
		...params,
	});

	const dateFilterModel = createDateFilterModel({
		fromChange: registryModel.filters.dateFrom.setValue,
		toChange: registryModel.filters.dateTo.setValue,
		reset: registryModel.clearFilters,
		optional: true,
	});

	return { registryModel, dateFilterModel };
};
